import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]

  connect() {
    this.updateCounter()
    this.inputTarget.addEventListener("input", this.updateCounter.bind(this))
    this.inputTarget.addEventListener("paste", this.handlePaste.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.updateCounter.bind(this))
    this.inputTarget.removeEventListener("paste", this.updateCounter.bind(this))
  }

  handlePaste(event) {
    const pastedText = (event.clipboardData || window.clipboardData).getData('text');

    // Strip out HTML tags
    const plainText = pastedText.replace(/<[^>]*>/g, ''); 

    let currentLength = this.inputTarget.value.length;
    let remaining;

    if (currentLength) {
        remaining = 500 - currentLength;
    }

    if (plainText.length > remaining) {
        event.preventDefault();
        this.inputTarget.value += plainText.substring(0, remaining); 
        this.updateCounter(); 
    } else {
        this.inputTarget.value += plainText;
        this.updateCounter();
    }
  }

  updateCounter() {
    let currentLength
    let remaining

    if(this.inputTarget.value){
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.inputTarget.value;
      const plainText = tempDiv.textContent || tempDiv.innerText || ''; // Handle browser inconsistencies

      currentLength = plainText.length; 
    }

    if(currentLength){
      remaining = 500 - currentLength
    }
    else {
      remaining = 500
    }

    this.counterTarget.textContent = `${remaining} characters remaining`

    if (remaining < 0) {
      this.counterTarget.classList.add("text-red-500") // Add a class for visual feedback
      this.inputTarget.classList.add("border-red-500")  // Highlight the input field
      this.inputTarget.value = this.inputTarget.value.substring(0, 500)
    } else {
      this.counterTarget.classList.remove("text-red-500")
      this.inputTarget.classList.remove("border-red-500")
    }
  }
}
